export var IDisplayOption;
(function (IDisplayOption) {
    IDisplayOption["MultiLine"] = "multi_lines";
    IDisplayOption["SingleImage"] = "single_image";
})(IDisplayOption || (IDisplayOption = {}));
